import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useChatAuth } from "@/context/ChatAuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChatAuthCallback() {
  const { exchangeEmergentSession } = useChatAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) {
      navigate("/chat-login", { replace: true });
      return;
    }
    exchangeEmergentSession(sessionId)
      .then(() => {
        // remove the fragment from the URL and go to chat
        window.history.replaceState({}, "", "/chat");
        navigate("/chat", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        navigate("/chat-login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center grain">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-yellow-400 animate-spin mx-auto" />
        <div className="overline mt-6">Authenticating…</div>
      </div>
    </div>
  );
}
